import launchdarklyFlags from './launchdarkly';

const root = {
	launchdarklyFlags
};

export default root;
